export const ERR_HISTORY_EMPTY = 'ERR_NAVIGATION_HISTORY_EMPTY';
export const ERR_CURSOR_INVALID = 'ERR_NAVIGATION_CURSOR_INVALID';